import React from 'react';

export default {
  TWITTER_HANDLE: {
    order: 2,
    icons: [ 'twitter' ],
    value: 'TWITTER_HANDLE',
    name: 'Twitter'
  },
  TWITTER_SEARCH: {
    order: 3,
    icons: [ 'search', 'twitter' ],
    value: 'TWITTER_SEARCH',
    name: 'Search Twitter'
  },
  INSTAGRAM_HANDLE: {
    order: 4,
    icons: [ 'instagram' ],
    value: 'INSTAGRAM_HANDLE',
    name: 'Instagram'
  },
  FACEBOOK_URL: {
    order: 6,
    icons: [ 'facebook-official' ],
    value: 'FACEBOOK_URL',
    name: 'Facebook'
  },
  EMAIL: {
    order: 1,
    icons: [ 'envelope' ],
    value: 'EMAIL',
    name: 'E-mail'
  },
  URL: {
    order: 5,
    icons: [ 'globe' ],
    value: 'URL',
    name: 'Website'
  },
  PHONE_NUMBER: {
    order: 0,
    icons: [ 'phone' ],
    value: 'PHONE_NUMBER',
    name: 'Phone Number'
  },
  ADDRESS: {
    order: 7,
    icons: [ 'address-card' ],
    value: 'ADDRESS',
    name: 'Address'
  }
};


// WEBPACK FOOTER //
// ./src/js/util/constants/contactInfoTypes.jsx